import React from "react";
import CategoryPage from "./CategoryPage";

const Special = () => {
    return <CategoryPage fixedCategory="Proudtapi" pageTitle="Proudtapi Special" />;
};

export default Special;
